export function setItem<T = object, TKeyValue extends string | number = string>(entity: T, keyValue: TKeyValue) {
  localStorage.setItem(keyValue.toString(), JSON.stringify(entity));
}

export function getItem<TKeyValue extends string | number = string>(keyValue: TKeyValue) {
  const entity = JSON.parse(localStorage.getItem(keyValue.toString()) || 'null');
  return entity;
}

export function removeItem<TKeyValue extends string | number = string>(keyValue: TKeyValue) {
  localStorage.removeItem(keyValue.toString());
}

export function clearStorage() {
  localStorage.clear();
}
